/** Suppress benign browser/extension noise from CRA’s fullscreen error overlay. */
export {};

const RESIZE_OBSERVER_LOOP =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
const METAMASK_CONNECT = /Failed to connect to MetaMask/i;
const CHROME_EXTENSION_SCRIPT = /^chrome-extension:\/\//i;

function isBenignOverlayNoise(message: string, filename?: string): boolean {
  if (RESIZE_OBSERVER_LOOP.test(message) || METAMASK_CONNECT.test(message)) {
    return true;
  }
  return typeof filename === 'string' && CHROME_EXTENSION_SCRIPT.test(filename);
}

function errorMessageFromUnknown(value: unknown): string {
  if (typeof value === 'string') return value;
  if (value instanceof Error) return value.message;
  if (value && typeof value === 'object' && 'message' in value) {
    const message = (value as { message?: unknown }).message;
    if (typeof message === 'string') return message;
  }
  return '';
}

if (typeof window !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;
  if (OriginalResizeObserver) {
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }
    } as typeof window.ResizeObserver;
  }

  window.addEventListener(
    'error',
    (event) => {
      if (isBenignOverlayNoise(event.message, event.filename)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (isBenignOverlayNoise(errorMessageFromUnknown(event.reason))) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  const originalConsoleError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    const first = args[0];
    if (typeof first === 'string' && isBenignOverlayNoise(first)) {
      return;
    }
    originalConsoleError(...args);
  };
}
